/* dm-px-b.js: gedrag van de galerij en het koopblok (sections/dm-px-koop.liquid).

   Galerij    pijlen en miniaturen schuiven de baan naar een beeld; bij schuiven volgen de pijlen (uit aan de
              uiteinden), de actieve miniatuur en de regel voor schermlezers.
   Koopoptie  een keuze verplaatst de markering, klapt de regels van die optie uit en zet het aantal (en het
              verkoopplan) in het formulier en het bedrag in de knop.

   Zonder dit script is de pagina te lezen en te kopen: de baan schuift met de vinger, de eerste optie is gekozen
   en de knop verstuurt het formulier. Alles hangt aan data-dm-b-attributen en werkt per sectie afzonderlijk. */
(function () {
  'use strict';

  // De sectie kan vaker op een pagina staan en zet dan vaker dit script: één keer uitvoeren is genoeg.
  if (window.dmPxB) {
    if (typeof window.dmPxB.start === 'function') window.dmPxB.start();
    return;
  }

  var RUST_MS = 120;                          // zo lang na het laatste schuiven staat de baan stil
  var DUUR_MS = 300;                          // uitklappen van een koopoptie
  var VERLOOP = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function lijst(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }
  function rustig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Galerij ------------------------------------------------------------------------------------------------- */

  var galerijen = new WeakMap();

  function delenVan(wortel) {
    var baan = wortel.querySelector('[data-dm-b-baan]');
    return {
      wortel: wortel,
      baan: baan,
      dias: baan ? lijst(baan.querySelectorAll('[data-dm-b-dia]')) : [],
      vorige: lijst(wortel.querySelectorAll('[data-dm-b-vorige]')),
      volgende: lijst(wortel.querySelectorAll('[data-dm-b-volgende]')),
      duimen: lijst(wortel.querySelectorAll('[data-dm-b-duim]')),
      strook: wortel.querySelector('[data-dm-b-duimen]'),
      live: lijst(wortel.querySelectorAll('[data-dm-b-live]'))
    };
  }

  // Schuifafstand per beeld, begrensd op wat de baan kan schuiven.
  function plekken(d) {
    var max = Math.max(0, d.baan.scrollWidth - d.baan.clientWidth);
    var nul = d.dias.length ? d.dias[0].offsetLeft : 0;
    return d.dias.map(function (dia) {
      return Math.min(Math.max(0, dia.offsetLeft - nul), max);
    });
  }

  function huidige(d) {
    var x = d.baan.scrollLeft;
    var beste = 0;
    var kleinste = Infinity;
    plekken(d).forEach(function (plek, i) {
      var afstand = Math.abs(plek - x);
      if (afstand < kleinste) {
        kleinste = afstand;
        beste = i;
      }
    });
    return beste;
  }

  // De actieve miniatuur binnen zijn eigen rij in beeld houden (de pagina zelf schuift niet mee).
  function duimInBeeld(d, index) {
    var duim = d.duimen[index];
    var strook = d.strook;
    if (!duim || !strook || strook.scrollWidth <= strook.clientWidth) return;
    var links = duim.offsetLeft;
    var rechts = links + duim.offsetWidth;
    if (links < strook.scrollLeft) strook.scrollLeft = links;
    else if (rechts > strook.scrollLeft + strook.clientWidth) strook.scrollLeft = rechts - strook.clientWidth;
  }

  function toon(staat, index, metMelding) {
    var d = staat.delen;
    var laatste = d.dias.length - 1;
    if (index === staat.getoond && !metMelding) return;
    staat.getoond = index;
    d.vorige.forEach(function (knop) { knop.disabled = index <= 0; });
    d.volgende.forEach(function (knop) { knop.disabled = index >= laatste; });
    d.duimen.forEach(function (duim, i) {
      var aan = i === index;
      duim.classList.toggle('is-actief', aan);
      if (aan) duim.setAttribute('aria-current', 'true');
      else duim.removeAttribute('aria-current');
    });
    duimInBeeld(d, index);
    if (metMelding) {
      var tekst = 'Beeld ' + (index + 1) + ' van ' + d.dias.length;
      d.live.forEach(function (regel) {
        if (regel.textContent !== tekst) regel.textContent = tekst;
      });
    }
  }

  function gaNaar(staat, index) {
    var d = staat.delen;
    index = Math.max(0, Math.min(d.dias.length - 1, index));
    var links = plekken(d)[index] || 0;
    staat.doel = index;
    try {
      d.baan.scrollTo({ left: links, behavior: rustig() ? 'auto' : 'smooth' });
    } catch (fout) {
      d.baan.scrollLeft = links;
    }
    toon(staat, index, true);
    wachtOpRust(staat);
  }

  function wachtOpRust(staat) {
    clearTimeout(staat.rust);
    staat.rust = setTimeout(function () {
      staat.doel = null;
      staat.vast = huidige(staat.delen);
      toon(staat, staat.vast, true);
    }, RUST_MS);
  }

  function bindGalerij(wortel) {
    var d = delenVan(wortel);
    if (!d.baan || !d.dias.length) return null;
    var staat = { delen: d, doel: null, rust: 0, getoond: -1, vast: 0 };
    galerijen.set(wortel, staat);
    d.baan.addEventListener('scroll', function () {
      // Onderweg naar een gekozen beeld blijft dat beeld gemarkeerd; bij schuiven met de vinger het dichtstbijzijnde.
      if (staat.doel === null) toon(staat, huidige(d), false);
      wachtOpRust(staat);
    }, { passive: true });
    staat.vast = huidige(d);
    toon(staat, staat.vast, true);
    return staat;
  }

  function galerijStaat(wortel) {
    if (!wortel) return null;
    return galerijen.get(wortel) || bindGalerij(wortel);
  }

  function klikInGalerij(knop) {
    var staat = galerijStaat(knop.closest('[data-dm-b-galerij]'));
    if (!staat) return;
    var d = staat.delen;
    var van = staat.doel !== null ? staat.doel : huidige(d);
    if (knop.hasAttribute('data-dm-b-vorige')) gaNaar(staat, van - 1);
    else if (knop.hasAttribute('data-dm-b-volgende')) gaNaar(staat, van + 1);
    else {
      var i = d.duimen.indexOf(knop);
      if (i >= 0) gaNaar(staat, i);
    }
  }

  // Na een andere schermbreedte (draaien, venster slepen) staat de baan niet meer precies op een beeld: zet hem
  // zonder beweging terug op het beeld waar hij stond en werk pijlen en miniaturen bij.
  function herteken() {
    lijst(document.querySelectorAll('[data-dm-b-galerij]')).forEach(function (wortel) {
      var staat = galerijen.get(wortel);
      if (!staat || staat.doel !== null) return;
      var d = staat.delen;
      var plek = plekken(d)[staat.vast];
      if (typeof plek === 'number' && Math.abs(d.baan.scrollLeft - plek) > 1) d.baan.scrollLeft = plek;
      staat.getoond = -1;
      toon(staat, staat.vast, false);
    });
  }

  /* Koopopties ------------------------------------------------------------------------------------------------ */

  var lopend = new WeakMap();

  function wisHoogte(el) {
    el.style.transition = '';
    el.style.height = '';
  }
  function stopHoogte(el) {
    var stop = lopend.get(el);
    if (stop) stop();
  }

  // Laat een kaart in 300 ms van zijn oude naar zijn nieuwe hoogte lopen en ruimt daarna de inline stijl op.
  function animeerHoogte(el, van, naar) {
    stopHoogte(el);
    if (van === naar || rustig()) {
      wisHoogte(el);
      return;
    }
    el.style.transition = 'none';
    el.style.height = van + 'px';
    void el.offsetHeight;
    el.style.transition = 'height ' + DUUR_MS + 'ms ' + VERLOOP;
    el.style.height = naar + 'px';
    var klaar = false;
    var klok = 0;
    function opruimen() {
      klaar = true;
      el.removeEventListener('transitionend', opEinde);
      clearTimeout(klok);
      lopend.delete(el);
    }
    function einde() {
      if (klaar) return;
      opruimen();
      wisHoogte(el);
    }
    function opEinde(e) {
      if (e.target === el && e.propertyName === 'height') einde();
    }
    klok = setTimeout(einde, DUUR_MS + 60);
    el.addEventListener('transitionend', opEinde);
    lopend.set(el, function () { if (!klaar) opruimen(); });
  }

  function kies(paneel, gekozen, bewegen) {
    var opties = lijst(paneel.querySelectorAll('[data-dm-b-optie]'));
    if (!opties.length || opties.indexOf(gekozen) < 0) return;
    var sleutel = gekozen.getAttribute('data-dm-b-optie');

    var voor = [];
    if (bewegen) {
      opties.forEach(function (optie) {
        voor.push(optie.offsetHeight);
        stopHoogte(optie);
        wisHoogte(optie);
      });
    }

    opties.forEach(function (optie) {
      var aan = optie === gekozen;
      optie.classList.toggle('is-gekozen', aan);
      var keuze = optie.querySelector('[data-dm-b-keuze]');
      if (keuze && keuze.checked !== aan) keuze.checked = aan;
      lijst(optie.querySelectorAll('[data-dm-b-regels]')).forEach(function (regels) {
        if (aan) regels.removeAttribute('hidden');
        else regels.setAttribute('hidden', '');
      });
    });

    // Het formulier: aantal en verkoopplan van de gekozen optie.
    var aantal = paneel.querySelector('[data-dm-b-aantal]');
    if (aantal) aantal.value = gekozen.getAttribute('data-aantal') || '1';
    var plan = paneel.querySelector('[data-dm-b-plan]');
    if (plan) plan.value = gekozen.getAttribute('data-plan') || '';

    // De knop: het bedrag van de gekozen optie.
    lijst(paneel.querySelectorAll('[data-dm-b-bedrag]')).forEach(function (bedrag) {
      if (bedrag.getAttribute('data-dm-b-bedrag') === sleutel) bedrag.removeAttribute('hidden');
      else bedrag.setAttribute('hidden', '');
    });

    if (bewegen) {
      opties.forEach(function (optie, i) {
        var na = optie.offsetHeight;
        if (na !== voor[i]) animeerHoogte(optie, voor[i], na);
      });
    }
  }

  // Bij het laden: volg de keuze die de browser onthouden heeft (terug-knop, herladen).
  function startOpties(paneel) {
    var aangevinkt = paneel.querySelector('[data-dm-b-keuze]:checked');
    var optie = aangevinkt ? aangevinkt.closest('[data-dm-b-optie]') : null;
    if (optie && !optie.classList.contains('is-gekozen')) kies(paneel, optie, false);
  }

  /* Starten ----------------------------------------------------------------------------------------------------- */

  function start(binnen) {
    var bereik = binnen && binnen.querySelectorAll ? binnen : document;
    lijst(bereik.querySelectorAll('[data-dm-b-galerij]')).forEach(galerijStaat);
    lijst(bereik.querySelectorAll('[data-dm-b-koop]')).forEach(startOpties);
  }

  document.addEventListener('click', function (e) {
    var doel = e.target && e.target.closest ? e.target : null;
    if (!doel) return;
    var knop = doel.closest('[data-dm-b-vorige], [data-dm-b-volgende], [data-dm-b-duim]');
    if (knop) klikInGalerij(knop);
  });

  document.addEventListener('change', function (e) {
    var keuze = e.target && e.target.matches && e.target.matches('[data-dm-b-keuze]') ? e.target : null;
    if (!keuze || !keuze.checked) return;
    var optie = keuze.closest('[data-dm-b-optie]');
    var paneel = keuze.closest('[data-dm-b-koop]');
    if (optie && paneel) kies(paneel, optie, true);
  });

  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  // In de theme editor: een aangeklikt blok komt in beeld (het beeld in de galerij, de koopoptie uitgeklapt).
  document.addEventListener('shopify:block:select', function (e) {
    var blok = e.target && e.target.matches ? e.target : null;
    if (!blok) return;
    if (blok.matches('[data-dm-b-dia]')) {
      var staat = galerijStaat(blok.closest('[data-dm-b-galerij]'));
      if (staat) gaNaar(staat, staat.delen.dias.indexOf(blok));
    } else if (blok.matches('[data-dm-b-optie]')) {
      var paneel = blok.closest('[data-dm-b-koop]');
      if (paneel) kies(paneel, blok, true);
    }
  });
  window.addEventListener('resize', herteken);
  window.addEventListener('load', herteken);
  window.addEventListener('pageshow', function () { start(document); });

  window.dmPxB = { start: start };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
})();
